import React from 'react';
import PageDirectory from '../components/PageDirectory';
import { DASHBOARD_PAGES } from '../config/dashboardPages';

// Directory of the plan dashboards, split out of Home so that page does not
// open with a dozen plan cards before anything else. The list and the card
// markup live elsewhere; this file only names the page.
function Dashboards() {
  return (
    <PageDirectory
      title="Brookline Notepad Dashboards"
      pages={DASHBOARD_PAGES}
      emptyText="You do not have access to any of the dashboards yet."
      disclaimer={
        <p>
          Each dashboard carries its own disclaimer and source information for the
          plan it presents.
        </p>
      }
    />
  );
}

export default Dashboards;
